import { createApp } from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'

axios.defaults.baseURL = 'https://actionstep.bikuta.xyz/api/'
createApp(App).use(router).use(axios).mount('#app')
